import { render, staticRenderFns } from "./faqThree.vue?vue&type=template&id=409b9c6a&"
import script from "./faqThree.vue?vue&type=script&lang=js&"
export * from "./faqThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports